/* eslint-disable react/button-has-type */
import cn from 'classnames';
import React from 'react';

import { CircularProgress } from 'components/basic/Loaders';

import s from './Button.module.scss';

export type ButtonSizes = 'small' | 'medium' | 'large';
export type ButtonLooks =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'rainbow'
  | 'ghost'
  | 'premium';

interface CustomProps {
  size?: ButtonSizes | undefined;
  look?: ButtonLooks | undefined;
  href?: string;
  className?: string;
  isDisabled?: boolean;
  isLoading?: boolean;
  grow?: boolean;
}

type IButtonProps = CustomProps &
  React.ButtonHTMLAttributes<HTMLButtonElement> &
  React.AnchorHTMLAttributes<HTMLAnchorElement>;

const Button: React.FC<IButtonProps> = props => {
  const {
    look = 'primary',
    size = 'large',
    type = 'button',
    children,
    className,
    href,
    isDisabled,
    isLoading,
    grow,
    ...restProps
  } = props;
  const classes = cn(
    s.button,
    {
      [s[size]]: s[size],
      [s[look]]: s[look],
      [s.grow]: grow,
      [s.isLoading]: isLoading,
    },
    className,
  );

  if (href) {
    return (
      <a
        href={href}
        className={classes}
        {...restProps}
        role="button"
        rel={props.target === '_blank' ? 'noopener noreferrer' : undefined}
      >
        {isLoading ? <CircularProgress /> : children}
      </a>
    );
  }

  return (
    <button
      className={classes}
      type={type}
      disabled={isDisabled || isLoading}
      {...restProps}
    >
      {isLoading ? <CircularProgress /> : children}
    </button>
  );
};

export default Button;
